import React from "react";
import Logo from "./Logo";

const Footer = () => {
  return (
    <div className="lg:p-10 p-5 border border-t">
      <div className="flex xs:flex-row flex-col xs:gap-0 gap-3 justify-between">
        <div className="flex flex-col gap-1">
            <Logo />
          <p>GST :36AABCJ3193K1ZC </p>
          <p>CIN : U29309TG1995PTC019103 </p>
        </div>
        <div className="lg:w-[25%] xs:w-[35%] flex flex-col gap-1">
          <h5 className="text-lg underline">Address</h5>
          <p>
            81 A/A, 12, MLA S COLONY, BANJARA HILLS, Hyderabad, Telangana,
            500034
          </p>
          <p>Contact No : 73829 80309</p>
          <p>Email : info@janica.co.in</p>
        </div>
      </div>
      <h3 className="text-white text-center pt-5">
        © 2026 Janica Electronics PVT LTD . All Rights Reserved.
      </h3>
    </div>
  );
};

export default Footer;
